/**
 * Centralised environment access (trimmed to what the Procedures portal needs).
 */
export const ENV = {
  CLIENT_SECRET: (import.meta.env.VITE_CLIENT_SECRET as string) || 'dev-secret-key',
  APP_VERSION: (import.meta.env.VITE_APP_VERSION as string) || '0.1.0',
  /** Fallback reCAPTCHA v2 site key when the portal settings do not carry one. */
  RECAPTCHA_SITE_KEY: (import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined) || undefined,
};

export const isDev = () => import.meta.env.DEV;
export const isProd = () => import.meta.env.PROD;
